<template>
  <div class="flexX">
    <!-- <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-if="breadCrumbValues.hasOwnProperty('step1')"><a
          @click="allFilters(breadCrumbValues.step1)">{{ breadCrumbValues.step1 }}</a></li>
        <li class="breadcrumb-item active" aria-current="page"
            v-if="breadCrumbValues.hasOwnProperty('step2') && breadCrumbValues.step2">{{ breadCrumbValues.step2 }}
        </li>
      </ol>
    </nav> -->
      <!-- :newList="newList" -->
    <GridCard
      v-if="isGridView"
      :newList="stories"
      @deleteStory="deleteStory($event)"
      @downloadStory="downloadStory($event)"
      @editStoryInfo="editStoryInfo($event)"
      @copyStory="copyStory($event)"
      @shareStory="shareStory($event)"
      @copyLink="copyLink($event)"
      @viewStoryDetail="viewStoryDetail($event)"
      @addToStarred="addToStarred($event)"
      @removeFromStarred="removeFromStarred($event)"
      @sort="setSortOrderListView"
    />
    <Table 
       v-else
      :data="stories"
      :config="config"
      @deleteStory="deleteStory($event)"
      @downloadStory="downloadStory($event)"
      @editStoryInfo="editStoryInfo($event)"
      @copyStory="copyStory($event)"
      @shareStory="shareStory($event)"
      @copyLink="copyLink($event)"
      @viewStoryDetail="viewStoryDetail($event)"
      @addToStarred="addToStarred($event)"
      @removeFromStarred="removeFromStarred($event)"
      @iconClicked="setSortOrderListView"
       />
  </div>
</template>


<script>
import {db} from '../../firebaseDB'
import Swal from 'sweetalert'
import GridCard from './gridCard1'
import ListCard from './listCard1'
import { log } from '@tensorflow/tfjs-core'
import Table from "../global/Table.vue"

export default {
  name: 'parentListGridCard',
  props: [
    'isGridView',
    'search',
    'searchByDate',
    'searchDateByCustom',
    'setSortOrder',
    'list',
    'organizations',
    'experienceFilter',
    'organizationsSideBar',
    'authorSideBar',
    'experienceFilterSideBar',
    'displayStarredData',
    'displaySharedData',
    'breadCrumbs'
  ],
  components: {
    ListCard,
    GridCard,
    Table
  },
  data () {
       return {
              newList: [],
              isInitialLoad: true,
              breadCrumbValues: {},
              initialLoad: true,
              storyContainer : [],
              sortVal : "t-a",
              config : { 
                action : "viewStoryDetail",
                hasCheckbox : true,
                border : true,
                columns : [
                    { 
                        name : "name",
                        key : "title",
                        width : "30%",
                        icon : {before : "title", after : null}
                    },
                    { 
                        name : "author",
                        key :  "author",
                        width : "30%",
                        icon : {before : "author", after : null}
                    },
                    { 
                        name : "last updated date",
                        key : "updated_at",
                        width : "30%",
                        icon : {before : "date", after : null}
                    },
                ],
                actions : {
                    name : "actions",
                    width : "30%",
                    icon : {after : null, before : null},
                    hasToggleList : true,
                    hasSimpleList : true,
                    elements : [
                        {
                            name : "view",
                            click : "view",
                            icon : null,
                            action : 'viewStoryDetail'
                        }
                    ],
                    list : [
                        {
                            icon : "decisionTree",
                            name : "Decision Tree",
                            action : this.goDecisionTree,
                            avaible : false
                        },
                        {
                            icon : "preview",
                            name : "Preview",
                            action : function(){},
                            avaible : false
                        },
                        {
                            icon : "share",
                            name : "Share",
                            action : this.shareStory,
                            avaible : true
                        },
                        {
                            icon : "getlink",
                            name : "Get link",
                            action : this.copyLink,
                            avaible : true
                        },
                        {
                            icon : null,
                            name : "show file location",
                            action : function(){},
                            avaible : false
                        },
                        {
                            icon : "noStarred",
                            size : { width : 16, height : 16},
                            name : "add to Starred",
                            action : this.addToStarred,
                            avaible : true
                        },
                        {
                            icon : "rename",
                            name : "Rename",
                            action : function(){},
                            avaible : false
                        },
                        {
                            icon : "copy",
                            name : "Make a copy",
                            action : this.copyStory,
                            avaible : true
                        },
                        {
                            icon : "edit",
                            name : "Edit",
                            action : this.editStoryInfo,
                            avaible : true
                        },
                        {
                            icon : "delete",
                            name : "Delete",
                            action : this.deleteStory,
                            avaible : true
                        },
                        {
                            icon : "download",
                            name : "Download",
                            action : this.downloadStory,
                            avaible : true
                        },
                    ]
                }
            }
          }
    
  },
  watch: {
    search: {
      handler: function (value) {
        let allFalse = true
        this.newList = []
        for (const valueKey in value) {
          if (value[valueKey].checked) {
            if (allFalse) {
              allFalse = false
            }

            this.$store.state.stories.map((value1) => {
              if (
                value1.hasOwnProperty('author') &&
                value1.author === value[valueKey].name) {
                this.newList.push(value1)
              }
            })
          }
        }
        if (allFalse) {
          this.newList = this.$store.state.stories
        }
      },
      deep: true
    },
    searchByDate: {
      handler: function (value) {
        let today = new Date()
        if (value === 'Last 3 Months') {
          today.setMonth(today.getMonth() - 3)
        } else if (value === 'Last 30 Days') {
          today.setMonth(today.getMonth() - 1)
        }
        today = today.toLocaleDateString()
        let extractDateByFormat = today.split('/')
        let searchDate =
          extractDateByFormat[2] +
          '-' +
          extractDateByFormat[1] +
          '-' +
          extractDateByFormat[0]
        searchDate = new Date(searchDate)
        this.newList = this.$store.state.stories.filter(
          (story) => new Date(story.date) > searchDate
        )
        this.newList =
          value === 'Any' ? this.$store.state.stories : this.newList
      },
      deep: true
    },
    searchDateByCustom: {
      handler: function (event) {
        let fromDate = event.fromDate
        let toDate = event.toDate
        this.newList = this.$store.state.stories.filter(
          (story) =>
            new Date(story.date) >= new Date(fromDate) &&
            new Date(story.date) <= new Date(toDate)
        )
      },
      deep: true
    },
    sortVal(value){
      // handler: function (value) {
        switch (value) {
          case 't-a':
           this.$store.state.stories = this.storyContainer = this.storyContainer.sort((a, b) => {
              return ('' + a.title).localeCompare(b.title)
            })
            break
          case 't-d':
           this.$store.state.stories = this.storyContainer = this.storyContainer.sort((a, b) => {
              return ('' + b.title).localeCompare(a.title)
            })
            break
          case 'd-a':
           this.$store.state.stories = this.storyContainer = this.storyContainer.sort((a, b) => {
              return new Date(a.date) - new Date(b.date)
            })
            break
          case 'd-d':
           this.$store.state.stories = this.storyContainer = this.storyContainer.sort((a, b) => {
              return new Date(b.date) - new Date(a.date)
            })
            break
          case 'a-a':
           this.$store.state.stories = this.storyContainer = this.storyContainer.sort((a, b) => {
              return ('' + a.author).localeCompare(b.author)
            })
            break
          case 'a-d':
           this.$store.state.stories = this.storyContainer = this.storyContainer.sort((a, b) => {
              return ('' + b.author).localeCompare(a.author)
            })
            break
          default:
            }
      // },
      // deep: true
    },
    setSortOrder(value){
      // handler: function (value) {
        switch (value) {
          case 't-a':
           this.$store.state.stories = this.storyContainer = this.storyContainer.sort((a, b) => {
              return ('' + a.title).localeCompare(b.title)
            })
            break
          case 't-d':
           this.$store.state.stories = this.storyContainer = this.storyContainer.sort((a, b) => {
              return ('' + b.title).localeCompare(a.title)
            })
            break
          case 'd-a':
           this.$store.state.stories = this.storyContainer = this.storyContainer.sort((a, b) => {
              return new Date(a.date) - new Date(b.date)
            })
            break
          case 'd-d':
           this.$store.state.stories = this.storyContainer = this.storyContainer.sort((a, b) => {
              return new Date(b.date) - new Date(a.date)
            })
            break
          case 'a-a':
           this.$store.state.stories = this.storyContainer = this.storyContainer.sort((a, b) => {
              return ('' + a.author).localeCompare(b.author)
            })
            break
          case 'a-d':
           this.$store.state.stories = this.storyContainer = this.storyContainer.sort((a, b) => {
              return ('' + b.author).localeCompare(a.author)
            })
            break
          default:
            }
      // },
      // deep: true
    },
    organizations: {
      handler: function (value) {
        let allFalse = true
        this.newList = []
        for (const valueKey in value) {
          if (value[valueKey].checked) {
            allFalse = false
            this.$store.state.stories.map((value1) => {
              if (
                value1.hasOwnProperty('organization') &&
                value1.organization === value[valueKey].name
              ) {
                this.newList = value1
              }
            })
          }
        }
        if (allFalse) {
          this.newList = this.$store.state.stories
        }
      },
      deep: true
    },
    experienceFilter: {
      handler: function (value) {
        let allFalse = true
        this.newList = []
        for (const valueKey in value) {
          if (value[valueKey].checked) {
            allFalse = false
            this.$store.state.stories.map((value1) => {
              if (
                value1.hasOwnProperty('experience') &&
                value1.experience.type === value[valueKey].name
              ) {
                this.newList.push(value1)
              }
            })
          }
        }
        if (allFalse) {
          this.newList = this.$store.state.stories
        }
      },
      deep: true
    },
    list: {
      handler: function (val) {
        this.loadInitialData()
      },
      deep: true
    },
    breadCrumbs: {
      handler: function (value) {
        this.breadCrumbValues = value
        this.newList = []
        if (this.breadCrumbValues.step1 === 'Organization') {
          this.organizationFilters()
        } else if (this.breadCrumbValues.step1 === 'Author') {
          this.authorFilters()
        } else {
          this.experienceFilters()
        }
      },
      deep: true
    },
    displayStarredData: {
      handler: function (val) {
        if (val === 'starred') {
          this.newList = this.$store.state.stories.filter(
            (story) => story.isStarred === true
          )
        } else {
          this.newList = this.$store.state.stories
        }
      },
      deep: true
    },
     displaySharedData: {
      handler: function (val) {
        if (val === 'shared') {
          this.newList = this.$store.state.stories.filter(
            (story) => story.sharedWith.includes(this.$store.state.user.id)
          )
        } else {
          this.newList = this.$store.state.stories
        }
      },
      deep: true
    }
  },

  mounted () {
    this.loadInitialData()
  },

  computed : {
    stories(){
      if(this.$store.state.stories.length > 0) this.storyContainer = [...this.$store.state.stories];
      if(this.$store.state.filters.length > 0) return this.filter();
      else {
        this.$store.state.storiesList = this.storyContainer;
        // return this.storyContainer.sort((a, b) => {
          //       return new Date(b.date) - new Date(a.date)
        //     });
        }
          return this.storyContainer;
      
    }
  },
  methods: {
    filter() {
      let filters = this.$store.state.filters;
      let list = [];
      for (const story of this.storyContainer) {
        let valid = true;
        for (const filter of filters) {
          if(['organization','author'].includes(filter.name) && !filter.children.includes(story[filter.name])) valid = false;
          if(filter.name == 'experience' && (!story.experience || story.experience && !filter.children.includes(story.experience.type))) valid = false;
          if(filter.name == 'starred' && !story.isStarred) valid = false;
          if(filter.name == 'shared' &&  ( !story.sharedWith ||!story.sharedWith.includes(this.$store.state.user.id) ) ) valid = false;
        }
        if(valid) list.push(story)
      }
      return list;
    },
    setSortOrderListView (value) {
      console.log("sort");
      if(value == "title") {this.sortVal = this.sortVal ? this.sortVal == "t-d" ? "t-a" : "t-d" : "t-d";}
      if(value == "author") {this.sortVal = this.sortVal ? this.sortVal == "a-d" ? "a-d" : "a-d" : "a-d";}
      if(value == "updated_at") {this.sortVal = this.sortVal ? this.sortVal == "d-d" ? "d-a" : "d-d" : "d-d";}
        this.$emit('sortOrderFilter', this.sortVal)
      // this.setSortOrder = this.sortVal // watch event to perform sorting
    },
    loadInitialData () {
      if (this.list.length && this.isInitialLoad) {
        this.newList = this.list
        this.isInitialLoad = false
      }
    },
    viewStoryDetail: function (story) {
      this.$router.push({name: 'project-dashboard', query: {title: story.title, id: story.id}})
    },
    editStoryInfo (story) {
      this.$emit('editStory', story)
    },
    copyStory (story) {
     const storiesRef = db.ref().child("stories");   
     let storyKey = storiesRef.push(story).key;
    db.ref(`stories/${storyKey}`).once('value').then(snapshot => {
     let copiedStory =snapshot.val()
     copiedStory.id=storyKey
     copiedStory.date = new Date().getFullYear()  + '-' +
                        (new Date().getMonth() + 1) + '-' +
                        new Date().getDate()
     copiedStory.title='Copy of '+copiedStory.title
     if(copiedStory.json){
     copiedStory.json.storyName='Copy of '+copiedStory.title
     }
     db.ref().child(`stories/${storyKey}`).update(copiedStory)
      })
 },
  shareStory (story) {
      this.$emit('shareStory', story)
 },
    copyLink (story) {
      this.$emit('copyLink', story)
    },
    addToStarred (story) {
      story.isStarred = true
      db.ref()
        .child(`stories/${story.id}`)
        .update(story)
        .then(() => {
          story.id = story.id
        })
      console.log(story)
      Swal({
        icon: 'info',
        title: `"${story.title}" story added to Starred`
      })
    },
    removeFromStarred (story) {
      if (this.displayStarredData === 'starred') {
        story.isStarred = false
        db.ref()
          .child(`stories/${story.id}`)
          .update(story)
          .then(() => {
            story.id = story.id
          })
        this.newList = this.$store.state.stories.filter(
          (story) => story.isStarred === true
        )
      } else {
        story.isStarred = false
        db.ref()
          .child(`stories/${story.id}`)
          .update(story)
          .then(() => {
            story.id = story.id
          })
      }
      Swal({
        icon: 'info',
        title: `"${story.title}" story removed from Starred`
      })
    },
    async deleteStory (story) {
      await Swal({
        title: `Do you want to delete "${story.title}" story?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        focusConfirm: false,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!'
      }).then((result) => {
        if (result) {
          db.ref()
            .child('stories/' + story.id)
            .remove()
          this.$store.dispatch('listUserStories')
          this.newList = this.$store.state.stories
          Swal({
            icon: 'success',
            title: `Deleted Story "${story.title}" !`,
            showConfirmButton: false,
            timer: 1000
          })
        }
      })
    },
   downloadStory (story) {
      this.download(JSON.stringify(story), story.id, "application/json");
    },
     download(content, fileName, contentType) {
		  const a = document.createElement("a");
		  const file = new Blob([content], { type: contentType });
		  a.href = URL.createObjectURL(file);
		  a.download = fileName;
		  a.click();
		},
    allFilters (filterType) {
      if (filterType === 'Organization') {
        this.filterOrganization()
      } else if (filterType === 'Author') {
        this.filterAuthor()
      } else {
        this.filterExperience()
      }
    },
    filterOrganization () {
      this.newList = []
      for (const valueKey in this.organizationsSideBar) {
        this.$store.state.stories.map((value1) => {
          if (
            value1.hasOwnProperty('organization') &&
            value1.organization === this.organizationsSideBar[valueKey].name
          ) {
            this.newList.push(value1)
          }
          this.organizationsSideBar[valueKey].checked = true
        })
        this.breadCrumbValues = {}
      }
    },
    filterAuthor () {
      this.newList = []
      for (const valueKey in this.authorSideBar) {
        this.$store.state.stories.map((value1) => {
          if (
            value1.hasOwnProperty('author') &&
            value1.author === this.authorSideBar[valueKey].name
          ) {
            this.newList.push(value1)
          }
          this.authorSideBar[valueKey].checked = true
        })
        this.breadCrumbValues = {}
      }
    },
    filterExperience () {
      this.newList = []
      for (const valueKey in this.experienceFilterSideBar) {
        this.$store.state.stories.map((value1) => {
          if (
            value1.hasOwnProperty('experience') &&
            value1.experience.type === this.experienceFilterSideBar[valueKey].name
          ) {
            this.newList.push(value1)
          }
          this.experienceFilterSideBar[valueKey].checked = true
        })
        this.breadCrumbValues = {}
      }
    },
    organizationFilters () {
      let allFalse = true
      this.initialLoad = true
      for (const valueKey in this.organizationsSideBar) {
        if (this.organizationsSideBar[valueKey].checked) {
          if (allFalse) {
            allFalse = false
            this.initialLoad = false
          }
          this.$store.state.stories.map((value1) => {
            if (
              value1.hasOwnProperty('organization') &&
              value1.organization === this.organizationsSideBar[valueKey].name
            ) {
              this.newList.push(value1)
            }
          })
        }
      }
      if (allFalse && this.initialLoad) {
        this.newList = this.$store.state.stories
      }
    },
    authorFilters () {
      let allFalse = true
      this.initialLoad = true
      for (const valueKey in this.authorSideBar) {
        if (this.authorSideBar[valueKey].checked) {
          if (allFalse) {
            allFalse = false
            this.initialLoad = false
          }
          this.$store.state.stories.map((value1) => {
            if (
              value1.hasOwnProperty('author') &&
              value1.author === this.authorSideBar[valueKey].name
            ) {
              this.newList.push(value1)
            }
          })
        }
      }
      if (allFalse && this.initialLoad) {
        this.newList = this.$store.state.stories
      }
    },
    experienceFilters () {
      let allFalse = true
      this.initialLoad = true
      for (const valueKey in this.experienceFilterSideBar) {
        if (this.experienceFilterSideBar[valueKey].checked) {
          if (allFalse) {
            allFalse = false
            this.initialLoad = false
          }
          this.$store.state.stories.map((value1) => {
            if (
              value1.hasOwnProperty('experience') &&
              value1.experience.type === this.experienceFilterSideBar[valueKey].name
            ) {
              this.newList.push(value1)
            }
          })
        }
      }
      if (allFalse && this.initialLoad) {
        this.newList = this.$store.state.stories
      }
    }
  }
}
</script>
<style scoped>

.flexX{
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;

}

.breadcrumb {
  background-color: transparent
}

.breadcrumb-item.active::before {
  content: '>'
}
</style>





// WEBPACK FOOTER //
// src/components/story-list-view/parentListGridCard.vue